import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { telemetry } from '@common/services/telemetry'

/**
 * Tracks page views on route changes — replaces AngularJS $locationChangeSuccess handler.
 * Prepends app name to path: "APS Single Lookup/disputes/list"
 */
export function usePageTracking(): void {
  const location = useLocation()
  const previousPath = useRef<string>('')

  useEffect(() => {
    const currentPath = location.pathname || '/'

    // Only track if path actually changed (avoid duplicate tracking)
    if (currentPath !== previousPath.current) {
      previousPath.current = currentPath

      // Match AngularJS format: appName + '/' + path (without leading slash)
      const pagePath = telemetry.appName + '/' + currentPath.replace(/^\//, '')
      telemetry.trackPageView(pagePath)
    }
  }, [location.pathname])
}
